import  { lazy } from "react";
import {
  ALIQOUT_PATHS,
  AUTH_PATHS,
  DASHBOARD_PATHS,
  LIBRARY_PATHS,
  MASTER_PERIOD_PATHS,
  SPONSOR_PATHS,
  MASTER_STUDY_PATHS,
  STUDY_LITE_PATHS,
  STUDY_PATHS,
  STUDY_VOLUNTEER_PATHS,
  VOLUNTEER_PATHS,
  MASTER_AE_PATHS,
  MASTER_TG_PATHS,
  IP_PATHS,
  DISPENSING_LOG_PATHS,
  LINE_CLEARANCE_PATHS,
  RETURNS_LOG_PATHS,
  STOCK_RECONCILIATION_PATHS,
  PRINT_LABEL_PATHS,
  PRINT_HISTORY_PATHS,
  ACCESSIONING_PATHS,
  RETENTION_PATHS,
  DISPOSAL_PATHS,
  TRANSFER_PATHS,
  STUDY_DESIGN_PATHS,
  AUDIT_PATHS,
  SCANNING_PATHS,
  REPORTS_PATHS,
  BLOCK_VOLUNTEER_PATHS,
  PRE_BLOCK_VOLUNTEER_PATHS,
  DROPOUT_VOLUNTEER_PATHS,
  TRANSFER_VOLUNTEER_PATHS,
  AMBULATORY_VISIT_PATHS,
  POST_STUDY_ASSESSMENT_PATHS,
  SUBJECT_CHECKIN_PATHS,
  SUBJECT_CHECKOUT_PATHS,
  SUBJECT_ADMISSION_PATHS,
  VERIFICATION_PATHS,
  IP_STORAGE_PATHS,
  STORAGE_PATHS,
  CENTRAL_REPORTS_PATHS,
} from "./paths";
import { Navigate } from "react-router-dom";
import {
  PERMISSION_ACTIONS,
  PERMISSION_MODULES,
} from "../common/constants/PermissionConstants";
import AccessRestricted from "Components/Common/AccessRestricted";
import VolunteerList from "modules/Volunteer/MasterVolunteer/pages/VolunteerList";
import CRFList from "modules/Library/CRF/pages/CRFList";
import CRFAdd from "modules/Library/CRF/pages/CRFAdd";
import CRFEdit from "modules/Library/CRF/pages/CRFEdit";
import VolunteerInfoTab from "modules/Volunteer/MasterVolunteer/components/VolunteernfoTab";
import VolunteerStudyInfoTab from "modules/Volunteer/MasterVolunteer/components/VolunteerStudyInfoTab";
import StudyScreeningTabs from "modules/Volunteer/AssigningStudyModule/StudyScreeningTabs/components/StudyScreeningTabs";
import ICFlist from "modules/Library/Checklist/pages/Checklist";
import DesignList from "modules/Library/Design/pages/Designlist";
import WorkflowBuilder from "modules/Library/Workflow/components/WorkflowBuilder";
import WorkflowStatusList from "modules/Library/Workflow/pages/WorkFlowList";
import WorkflowView from "modules/Library/Workflow/pages/ViewWorkflow";
import StudyRoleList from "modules/Library/Role/pages/RoleList";
import SponsorList from "../modules/Library/Sponsor/pages/SponsorList";
import AliquotList from "modules/Library/Aliquote/pages/AliquotList";
import DetailsList from "../modules/Study/Study/pages/StudyList";
import TemplateList from "modules/Library/Template/pages/TemplateList";
import AddTemplate from "modules/Library/Template/pages/AddTemplate";
import EditTemplate from "modules/Library/Template/pages/EditTemplate";
import ViewTemplate from "modules/Library/Template/pages/ViewTemplate";
import AdverseEventDashboard from "modules/Library/AdverseEvent/pages/AdverseEventList";
import TrainingGroupList from "modules/Library/TrainingGroup/pages/TrainingGroupList";
import AdverseEventAdd from "modules/Library/AdverseEvent/pages/AddAdverseEvent";
import UserList from "modules/Library/Users/pages/UserList";
import AdverseEventEdit from "modules/Library/AdverseEvent/pages/EditAdverseEvent";
import AdverseEventView from "modules/Library/AdverseEvent/pages/AdverseEventView";
import IpInventoryAdd from "modules/Pharmacy/IPinventory/pages/AddIpInventory";
import IpInventoryEdit from "modules/Pharmacy/IPinventory/pages/EditIpInventory";
import StudyAttachments from "modules/Study/Attachments/pages/AttachmentFolder";
import IpInventoryList from "modules/Pharmacy/IPinventory/pages/IpInventoryList";
import AddDispensingLog from "modules/Pharmacy/Dispensing/pages/AddDispensingLog";
import AddLineClearance from "modules/Pharmacy/LineClearance/pages/AddLineClearance";
import DispensingLogList from "modules/Pharmacy/Dispensing/pages/DispensingLogList";
import AddReturnsLog from "modules/Pharmacy/ReturnsLog/pages/AddReturnsLog";
import IpInventoryView from "modules/Pharmacy/IPinventory/pages/ViewIpInventory";
import LISTReturnsLog from "modules/Pharmacy/ReturnsLog/pages/ReturnsLogList";
import DispensingLogView from "modules/Pharmacy/Dispensing/pages/ViewDispensingLog";
import StockReconciliationList from "modules/Pharmacy/DailyReconsilation/pages/StockReconciliationList";
import VIEWReturnsLog from "modules/Pharmacy/ReturnsLog/pages/ViewReturnsLog";
import SubjectCheckinList from "modules/Clinical/CheckinCheckout/pages/SubjectCheckinList";
import SubjectCheckoutList from "modules/Clinical/CheckinCheckout/pages/SubjectCheckoutList";
import ViewSubjectCheckin from "modules/Clinical/CheckinCheckout/pages/ViewSubjectCheckin";
import ViewSubjectCheckout from "modules/Clinical/CheckinCheckout/pages/ViewSubjectCheckout";
import PrintLogsTabs from "modules/PrintLabel/MainPrintListTabs/pages/PrintLogsTabs";
import SubjectLabelList from "modules/PrintLabel/RePrintListTabs/pages/RePrintLabelList";
import AccessioningList from "modules/Session/Session/pages/SessionList";
import ManualEntryPage from "modules/Session/ManualEntry/pages/ManualEntryPage";
import SessionLogView from "modules/Session/Session/pages/SessionLogView";
import AccessioningSession from "modules/Session/Session/pages/ActiveSessionResponsive";
import PeriodList from "modules/Library/Period/pages/PeriodList";
import RetentionList from "modules/Pharmacy/Retention/pages/RetentionList";
import RetentionAdd from "modules/Pharmacy/Retention/pages/AddRetention";
import RetentionView from "modules/Pharmacy/Retention/pages/ViewRetention";
import DisposalList from "modules/Pharmacy/Disposal/pages/DisposalList";
import DisposalAdd from "modules/Pharmacy/Disposal/pages/AddDisposal";
import DisposalView from "modules/Pharmacy/Disposal/pages/ViewDisposal";
import TransferList from "modules/Pharmacy/Transfer/pages/TransferList";
import TransferAdd from "modules/Pharmacy/Transfer/pages/AddTransfer";
import TransferView from "modules/Pharmacy/Transfer/pages/ViewTransfer";
import StudyDesignTabs from "modules/Clinical/StudyDesign/pages/StudyDesignTabs";
import WorkflowDashboard from "modules/Study/StudyWorkflow/pages/WorkflowDashboard";
import WorkflowReview from "modules/Study/StudyWorkflow/pages/WorkflowReview";
import AuditLog from "modules/Audit/pages/AuditLog";
import ScannerPage from "modules/ScanningApp/pages/ScannerPage";
import ScanningSessionPage from "modules/ScanningApp/pages/ScanningSessionPage";
import ScanningSessionLogView from "modules/ScanningApp/pages/ScanningSessionLogView";
import StockSummaryReport from "modules/Pharmacy/Reports/pages/StockSummaryReport";
import SummaryReports from "modules/Pharmacy/Reports/pages/SummaryReports";
import StockExpiryReport from "modules/Pharmacy/Reports/pages/StockExpiryReport";
import SubjectWiseReport from "modules/Pharmacy/Reports/pages/SubjectWiseReport";
import StockLedgerReport from "modules/Pharmacy/Reports/pages/StockLedgerReport";
import RoleRightsMatrix from "modules/Library/Role/components/RoleRightsMatrix";
import AddBlockVolunteer from "modules/Volunteer/BlockVolunteer/pages/AddBlockVolunteer";
import AddPreBlockVolunteer from "modules/Volunteer/BlockVolunteer/pages/AddPreBlockVolunteer";
import BlockVolunteerList from "modules/Volunteer/BlockVolunteer/pages/BlockVolunteerList";
import ViewBlockVolunteer from "modules/Volunteer/BlockVolunteer/pages/ViewBlockVolunteer";
import DropoutVolunteerList from "modules/Volunteer/DropoutVolunteer/pages/DropoutVolunteerList";
import AddDropoutVolunteer from "modules/Volunteer/DropoutVolunteer/pages/AddDropoutVolunteer";
import ViewDropoutVolunteer from "modules/Volunteer/DropoutVolunteer/pages/ViewDropoutVolunteer";
import AddTransferVolunteer from "modules/Volunteer/TransferVolunteer/pages/AddTransferVolunteer";
import TransferVolunteerList from "modules/Volunteer/TransferVolunteer/pages/TransferVolunteerList";
import ViewTransferVolunteer from "modules/Volunteer/TransferVolunteer/pages/ViewTransferVolunteer";
import AmbulatoryVisitList from "modules/Clinical/AmbulatoryVisit/pages/AmbulatoryVisitList";
import AmbulatoryVisitDetail from "modules/Clinical/AmbulatoryVisit/pages/AmbulatoryVisitDetail";
import ViewAmbulatoryVisit from "modules/Clinical/AmbulatoryVisit/pages/ViewAmbulatoryVisit";
import AmbulatorySubjectDetail from "modules/Clinical/AmbulatoryVisit/pages/AmbulatorySubjectDetail";
import ViewAmbulatorySubjectDetail from "modules/Clinical/AmbulatoryVisit/pages/ViewAmbulatorySubjectDetail";
import PostStudyAssessmentSubjectDetail from "modules/Clinical/PostStudyAssessment/pages/PostStudyAssessmentSubjectDetail";
import SingleStudyDashboard from "modules/Dashboard/pages/SingleStudyDashboard";
import SampleCollectionVerification from "modules/Verification/pages/SampleCollectionVerification";
import SessionDashboard from "modules/Session/Session/pages/SessionDashboard";
import LineClearanceList from "modules/Pharmacy/LineClearance/pages/LineClearanceList";
import ViewLineClearance from "modules/Pharmacy/LineClearance/pages/ViewLineClearance";
import UserActivity from "modules/Audit/pages/UserActivity";
import IpStorageList from "modules/Pharmacy/IPStorage/pages/IpStorageList";
import AddIpStorage from "modules/Pharmacy/IPStorage/pages/AddIpStorage";
import UserListSSO from "modules/Library/Accounts/pages/UserList";
// import WorkflowLiteReview from "modules/Study/StudyLiteWorkflow/pages/WorkflowLiteReview";



// ✅ Lazy imports (pages load only when visited)
const Login = lazy(() => import("../modules/Authentication/Login"));
const Logout = lazy(() => import("../modules/Authentication/Logout"));
const MultiTabRestrict = lazy(
  () => import("../modules/Authentication/MultitabRestrict"),
);
const UnauthorizedAccess = lazy(
  () => import("../modules/Authentication/UnauthorizedAccess"),
);
const LicenseExpired = lazy(
  () => import("../modules/Authentication/licenseExpired"),
);
const CodeList = lazy(
  () => import("../modules/Library/CodeList/pages/CodeList"),
);
const StudyTabs = lazy(() => import("../modules/Clinical/ClinicalTabs/components/ClinicalTabs"));

const CRFPreview = lazy(
  () => import("../modules/Library/CRF/pages/CRFPreview"),
);
const StudyList = lazy(() => import("../modules/Clinical/ClinicalStudyList/pages/ClinicalStudyList"));
const AllStudyDashboard = lazy(() => import("../modules/Dashboard/pages/AllStudyDashboard"));
const VolunteerStudyScreeningList = lazy(
  () =>
    import("../modules/Volunteer/AssigningStudyModule/VolunteerStudyScreeningList/pages/VolunteerStudyScreeningList"),
);

const StudyMaster = lazy(
  () => import("../modules/Study/Study/components/StudyMaster"),
);

const StudyLiteList = lazy(
  () => import("../modules/Study/StudyLite/pages/StudyLiteList"),
);

const AddEditStudyLitePage = lazy(
  () => import("../modules/Study/StudyLite/pages/AddEditStudyLitePage"),
);

const ViewStudyLitePage = lazy(
  () => import("../modules/Study/StudyLite/pages/ViewStudyLitePage"),
);

const WorkflowLiteReview = lazy(
  () => import("../modules/Study/StudyLiteWorkflow/pages/WorkflowLiteReview"),
);

const StudyHistoryDetails = lazy(
  () => import("../modules/Study/Study/pages/StudyHistoryDetails"),
);

const RolesList = lazy(() => import("../modules/Library/Role/pages/RoleList"));

const AddStudyPage = lazy(
  () => import("../modules/Study/Study/pages/AddStudyForm"),
);

const AssignTrainingGroupPage = lazy(
  () => import("modules/Library/TrainingGroup/pages/AssignTrainingGroupPage"),
);

const SystemSettings = lazy(
  () => import("../modules/Clinical/Settings/pages/SystemSettings"),
);

const FeatureActivation = lazy(
  () => import("../modules/Library/FeatureActivation/pages/FeatureActivation"),
);
const UnitList = lazy(
  () => import("modules/Library/BedManagement/pages/UnitList"),
);
const RoomList = lazy(
  () => import("modules/Library/BedManagement/pages/RoomList"),
);
const BedList = lazy(
  () => import("modules/Library/BedManagement/pages/BedList"),
);
const ViewFacilityOverview = lazy(
  () => import("modules/Library/BedManagement/pages/ViewFacilityOverview"),
);
const StorageDashboard = lazy(
  () => import("modules/Clinical/Storage/pages/StorageDashboard"),
);
const StorageUnitDetail = lazy(
  () => import("modules/Clinical/Storage/pages/StorageUnitDetail"),
);
const AddStorageUnitPage = lazy(
  () => import("modules/Clinical/Storage/pages/AddStorageUnitPage"),
);

const ReportCenter = lazy(
  () => import("modules/Audit/pages/ReportCenter"),
);

// ✅ Route arrays
const authProtectedRoutes = [
  { path: DASHBOARD_PATHS.DEFAULT, component: <AllStudyDashboard />, module: PERMISSION_MODULES.DASHBOARD },
  {
    path: AUTH_PATHS.LOGIN,
    exact: true,
    component: <Navigate to={DASHBOARD_PATHS.DEFAULT} />,
  },
    {
    path: AUTH_PATHS.LOGIN,
    exact: true,
    component: <Navigate to={ACCESSIONING_PATHS.DASHBOARD} />,
  },
  {
    path: LIBRARY_PATHS.CODE_LIST,
    component: <CodeList />,
    module: PERMISSION_MODULES.CODE_LIST,
  },

  {
    path: LIBRARY_PATHS.CRF_LIST,
    component: <CRFList />,
    module: PERMISSION_MODULES.CRF,
  },
  {
    path: LIBRARY_PATHS.CRF_PREVIEW,
    component: <CRFPreview />,
    showHeader: false,
    module: PERMISSION_MODULES.CRF,
  },
  {
    path: LIBRARY_PATHS.CRF_ADD,
    component: <CRFAdd />,
    showHeader: false,
    module: PERMISSION_MODULES.CRF,
  },
  {
    path: LIBRARY_PATHS.CRF_EDIT,
    component: <CRFEdit />,
    showHeader: false,
    module: PERMISSION_MODULES.CRF,
  },
  {
    path: LIBRARY_PATHS.CHECKLIST_DETAIL,
    component: <ICFlist />,
    module: PERMISSION_MODULES.CHECKLIST,
  },
  {
    path: LIBRARY_PATHS.DESIGN_LIST,
    component: <DesignList />,
    module: PERMISSION_MODULES.DESIGN,
  },
  {
    path: LIBRARY_PATHS.WORKFLOW_ADD,
    component: <WorkflowBuilder />,
    showHeader: false,
    module: PERMISSION_MODULES.WORKFLOW,
  },
  {
    path: LIBRARY_PATHS.WORKFLOW_LIST,
    component: <WorkflowStatusList />,
    module: PERMISSION_MODULES.WORKFLOW,
  },
  {
    path: LIBRARY_PATHS.WORKFLOW_VIEW,
    component: <WorkflowView />,
    showHeader: false,
    module: PERMISSION_MODULES.WORKFLOW,
  },
  {
    path: LIBRARY_PATHS.WORKFLOW_EDIT,
    component: <WorkflowBuilder />,
    showHeader: false,
    module: PERMISSION_MODULES.WORKFLOW,
  },
  {
    path: LIBRARY_PATHS.ROLE_LIST,
    component: <StudyRoleList />,
    module: PERMISSION_MODULES.ROLE,
  },
  {
    path: LIBRARY_PATHS.ASSIGN_RIGHTS,
    component: <RoleRightsMatrix />,
    showHeader: false,
    module: PERMISSION_MODULES.ROLE,
    action: PERMISSION_ACTIONS.ASSIGN_RIGHTS,
  },
  {
    path: LIBRARY_PATHS.USER_LIST,
    component: <UserList />,
    module: PERMISSION_MODULES.USER,
  },
  {
    path: LIBRARY_PATHS.ACCOUNTS_LIST,
    component: <UserListSSO />,
  },
  {
    path: LIBRARY_PATHS.TEMPLATE_LIST,
    component: <TemplateList />,
    module: PERMISSION_MODULES.TEMPLATE,
  },
  {
    path: LIBRARY_PATHS.TEMPLATE_ADD,
    component: <AddTemplate />,
    showHeader: false,
    module: PERMISSION_MODULES.TEMPLATE,
  },
  {
    path: LIBRARY_PATHS.TEMPLATE_EDIT,
    component: <EditTemplate />,
    showHeader: false,
    module: PERMISSION_MODULES.TEMPLATE,
  },
  {
    path: LIBRARY_PATHS.TEMPLATE_VIEW,
    component: <ViewTemplate />,
    showHeader: false,
    module: PERMISSION_MODULES.TEMPLATE,
  },
  {
    path: LIBRARY_PATHS.UNIT_LIST,
    component: <UnitList />,
    module: PERMISSION_MODULES.BED_MANAGEMENT,
  },
  {
    path: LIBRARY_PATHS.ROOM_LIST,
    component: <RoomList />,
    module: PERMISSION_MODULES.BED_MANAGEMENT,
  },
  {
    path: LIBRARY_PATHS.BED_LIST,
    component: <BedList />,
    module: PERMISSION_MODULES.BED_MANAGEMENT,
  },
  {
    path: LIBRARY_PATHS.BED_MANAGEMENT_VIEW,
    component: <ViewFacilityOverview />,
    module: PERMISSION_MODULES.BED_MANAGEMENT,
  },
  {
    path: VOLUNTEER_PATHS.LIST,
    component: <VolunteerList />,
    module: PERMISSION_MODULES.VOLUNTEER,
  },

  {
    path: STUDY_PATHS.LIST,
    component: <StudyList />,
    module: `${PERMISSION_MODULES.STUDY_DESIGN},${PERMISSION_MODULES.SUBJECTS},${PERMISSION_MODULES.SUBJECT_CHECKIN},${PERMISSION_MODULES.SUBJECT_CHECKOUT},${PERMISSION_MODULES.DOSING_SCHEDULE},${PERMISSION_MODULES.PARTICIPANTS},${PERMISSION_MODULES.TIME_POINT},${PERMISSION_MODULES.SESSION_SUBJECTS},${PERMISSION_MODULES.SESSION_PARTICIPANTS}`,
  },
  {
    path: STUDY_PATHS.DASHBOARD,
    component: <AllStudyDashboard />,
    showHeader: false,
  },
  {
    path: STUDY_PATHS.SINGLE_DASHBOARD,
    component: <SingleStudyDashboard />,
    showHeader: false,
  },
  {
    path: STUDY_PATHS.DETAILS,
    component: <StudyTabs />,
    showHeader: false,
    module: `${PERMISSION_MODULES.STUDY_DESIGN},${PERMISSION_MODULES.CLINICAL},${PERMISSION_MODULES.SUBJECTS},${PERMISSION_MODULES.SUBJECT_CHECKIN},${PERMISSION_MODULES.SUBJECT_CHECKOUT},${PERMISSION_MODULES.DOSING_SCHEDULE},${PERMISSION_MODULES.PARTICIPANTS},${PERMISSION_MODULES.AMBULATORY_VISIT},{PERMISSION_MODULES.TIME_POINT} {PERMISSION_MODULES.SESSION_PARTICIPANTS}`,
  },
  {
    path: STUDY_PATHS.SCREENING,
    component: <StudyScreeningTabs />,
    showHeader: false,
    module: PERMISSION_MODULES.STUDY_SCREENING,
  },
  {
    path: `${STUDY_VOLUNTEER_PATHS.DETAILS}/:id/*`,
    component: <VolunteerStudyInfoTab />,
    showHeader: false,
    module: PERMISSION_MODULES.VOLUNTEER,
  },
  {
    path: `${VOLUNTEER_PATHS.DETAILS}/:id/*`,
    component: <VolunteerInfoTab />,
    showHeader: false,
    module: PERMISSION_MODULES.VOLUNTEER,
  },
  {
    path: STUDY_PATHS.SCREENING_LIST,
    component: <VolunteerStudyScreeningList />,
    module: PERMISSION_MODULES.STUDY_SCREENING,
  },
  {
    path: SPONSOR_PATHS.LIST,
    component: <SponsorList />,
    module: PERMISSION_MODULES.SPONSOR,
  },
  {
    path: MASTER_PERIOD_PATHS.LIST,
    component: <PeriodList />,
    module: PERMISSION_MODULES.PERIOD,
  },
  {
    path: ALIQOUT_PATHS.LIST,
    component: <AliquotList />,
    module: PERMISSION_MODULES.ALIQUOT,
  },
  {
    path: MASTER_STUDY_PATHS.ADD,
    component: <AddStudyPage />,
    module: PERMISSION_MODULES.STUDY,
  },
  {
    path: MASTER_STUDY_PATHS.DETAILS,
    component: <StudyMaster />,
    showHeader: false,
    module: PERMISSION_MODULES.STUDY,
  },
  {
    path: MASTER_STUDY_PATHS.HISTORY_DETAILS,
    component: <StudyHistoryDetails />,
    showHeader: false,
    module: PERMISSION_MODULES.STUDY,
  },
  {
    path: MASTER_STUDY_PATHS.LIST,
    component: <DetailsList />,
    module: PERMISSION_MODULES.STUDY,
  },
  {
    path: STUDY_LITE_PATHS.LIST,
    component: <StudyLiteList />,
    module: PERMISSION_MODULES.STUDY,
  },
  {
    path: STUDY_LITE_PATHS.ADD,
    component: <AddEditStudyLitePage />,
    module: PERMISSION_MODULES.STUDY,
  },
  {
    path: STUDY_LITE_PATHS.EDIT,
    component: <AddEditStudyLitePage />,
    module: PERMISSION_MODULES.STUDY,
  },
  {
    path: STUDY_LITE_PATHS.VIEW,
    component: <ViewStudyLitePage />,
    module: PERMISSION_MODULES.STUDY,
  },
  {
    path: STUDY_LITE_PATHS.WORKFLOW_REVIEW,
    component: <WorkflowLiteReview />,
    showHeader: false,
    module: PERMISSION_MODULES.STUDY,
  },
  {
    path: MASTER_STUDY_PATHS.ROLE,
    component: <RolesList />,
    module: PERMISSION_MODULES.ROLE,
  },
  {
    path: MASTER_STUDY_PATHS.ATTACHMENTS,
    component: <StudyAttachments />,
    module: PERMISSION_MODULES.DOCUMENT_MANAGEMENT,
  },
  { path: "/qaqc", component: <WorkflowDashboard />, module: PERMISSION_MODULES.WORKFLOW },
  {
    path: "/qaqc/review/:id",
    component: <WorkflowReview />,
    showHeader: false,
    module: PERMISSION_MODULES.STUDY,
  },
  {
    path: MASTER_AE_PATHS.LIST,
    component: <AdverseEventDashboard />,
    module: PERMISSION_MODULES.ADVERSE_EVENT,
  },
  {
    path: MASTER_TG_PATHS.LIST,
    component: <TrainingGroupList />,
    module: PERMISSION_MODULES.TRAINING_GROUP,
  },
  {
    path: MASTER_TG_PATHS.ASSIGN_TRAINING,
    component: <AssignTrainingGroupPage />,
    module: PERMISSION_MODULES.TRAINING_GROUP,
    action: PERMISSION_ACTIONS.VIEW,
  },
  {
    path: MASTER_AE_PATHS.ADD,
    component: <AdverseEventAdd />,
    module: PERMISSION_MODULES.ADVERSE_EVENT,
    action: PERMISSION_ACTIONS.ADD,
  },
  {
    path: MASTER_AE_PATHS.EDIT,
    component: <AdverseEventEdit />,
    module: PERMISSION_MODULES.ADVERSE_EVENT,
    action: PERMISSION_ACTIONS.EDIT,
  },
  {
    path: MASTER_AE_PATHS.VIEW,
    component: <AdverseEventView />,
    module: PERMISSION_MODULES.ADVERSE_EVENT,
    action: PERMISSION_ACTIONS.VIEW,
  },

  {
    path: IP_PATHS.ADD,
    component: <IpInventoryAdd />,
    module: PERMISSION_MODULES.IP_INVENTORY,
    action: PERMISSION_ACTIONS.ADD,
  },
  {
    path: IP_PATHS.EDIT,
    component: <IpInventoryEdit />,
    module: PERMISSION_MODULES.IP_INVENTORY,
    action: PERMISSION_ACTIONS.EDIT,
  },
  {
    path: IP_PATHS.LIST,
    component: <IpInventoryList />,
    module: PERMISSION_MODULES.IP_INVENTORY,
  },
  {
    path: IP_PATHS.VIEW,
    component: <IpInventoryView />,
    module: PERMISSION_MODULES.IP_INVENTORY,
    action: PERMISSION_ACTIONS.VIEW,
  },

  {
    path: IP_STORAGE_PATHS.ADD,
    component: <AddIpStorage />,
    module: PERMISSION_MODULES.IP_STORAGE,
    action: PERMISSION_ACTIONS.ADD,
  },
  {
    path: IP_STORAGE_PATHS.LIST,
    component: <IpStorageList />,
    module: PERMISSION_MODULES.IP_STORAGE,
  },

  {
    path: DISPENSING_LOG_PATHS.ADD,
    component: <AddDispensingLog />,
    module: PERMISSION_MODULES.DISPENSING_LOG,
    action: PERMISSION_ACTIONS.ADD,
  },
  {
    path: DISPENSING_LOG_PATHS.LIST,
    component: <DispensingLogList />,
    module: PERMISSION_MODULES.DISPENSING_LOG,
  },
  {
    path: DISPENSING_LOG_PATHS.EDIT,
    component: <AddDispensingLog />,
    module: PERMISSION_MODULES.DISPENSING_LOG,
    action: PERMISSION_ACTIONS.EDIT,
  },
  {
    path: DISPENSING_LOG_PATHS.VIEW,
    component: <DispensingLogView />,
    module: PERMISSION_MODULES.DISPENSING_LOG,
    action: PERMISSION_ACTIONS.VIEW,
  },
  {
    path: LINE_CLEARANCE_PATHS.ADD,
    component: <AddLineClearance />,
    module: PERMISSION_MODULES.LINE_CLEARANCE,
    action: PERMISSION_ACTIONS.ADD,
  },
  {
    path: LINE_CLEARANCE_PATHS.EDIT,
    component: <AddLineClearance />,
    module: PERMISSION_MODULES.LINE_CLEARANCE,
    action: PERMISSION_ACTIONS.EDIT,
  },
  {
    path: LINE_CLEARANCE_PATHS.VIEW,
    component: <ViewLineClearance />,
    module: PERMISSION_MODULES.LINE_CLEARANCE,
    action: PERMISSION_ACTIONS.VIEW,
  },
  {
    path: LINE_CLEARANCE_PATHS.LIST,
    component: <LineClearanceList />,
    module: PERMISSION_MODULES.LINE_CLEARANCE,
  },

  {
    path: RETURNS_LOG_PATHS.ADD,
    component: <AddReturnsLog />,
    module: PERMISSION_MODULES.RETURNS_LOG,
    action: PERMISSION_ACTIONS.ADD,
  },
  {
    path: RETURNS_LOG_PATHS.LIST,
    component: <LISTReturnsLog />,
    module: PERMISSION_MODULES.RETURNS_LOG,
  },

  {
    path: STOCK_RECONCILIATION_PATHS.LIST,
    component: <StockReconciliationList />,
    module: PERMISSION_MODULES.STOCK_RECONCILIATION,
  },

  {
    path: RETURNS_LOG_PATHS.EDIT,
    component: <AddReturnsLog />,
    module: PERMISSION_MODULES.RETURNS_LOG,
    action: PERMISSION_ACTIONS.EDIT,
  },
  {
    path: RETURNS_LOG_PATHS.VIEW,
    component: <VIEWReturnsLog />,
    module: PERMISSION_MODULES.RETURNS_LOG,
    action: PERMISSION_ACTIONS.VIEW,
  },
  {
    path: SUBJECT_ADMISSION_PATHS.LIST,
    component: <Navigate to={SUBJECT_CHECKIN_PATHS.LIST} replace />,
  },
  {
    path: SUBJECT_CHECKIN_PATHS.LIST,
    component: <SubjectCheckinList />,
    module: PERMISSION_MODULES.SUBJECT_CHECKIN,
  },
  {
    path: SUBJECT_CHECKIN_PATHS.VIEW,
    component: <ViewSubjectCheckin />,
    module: PERMISSION_MODULES.SUBJECT_CHECKIN,
    action: PERMISSION_ACTIONS.VIEW,
  },
  {
    path: SUBJECT_CHECKOUT_PATHS.LIST,
    component: <SubjectCheckoutList />,
    module: PERMISSION_MODULES.SUBJECT_CHECKOUT,
  },
  {
    path: SUBJECT_CHECKOUT_PATHS.VIEW,
    component: <ViewSubjectCheckout />,
    module: PERMISSION_MODULES.SUBJECT_CHECKOUT,
    action: PERMISSION_ACTIONS.VIEW,
  },
  {
    path: SUBJECT_ADMISSION_PATHS.VIEW,
    component: <ViewSubjectCheckin />,
    module: PERMISSION_MODULES.SUBJECT_CHECKIN,
    action: PERMISSION_ACTIONS.VIEW,
  },

  {
    path: `${PRINT_LABEL_PATHS.TABS}/*`,
    component: <PrintLogsTabs />,
    module: `${PERMISSION_MODULES.SUBJECT_LABEL},${PERMISSION_MODULES.SUBJECT_ICARD_LABEL},${PERMISSION_MODULES.VACUTAINER_LABEL},${PERMISSION_MODULES.RIAVIAL_LABEL},${PERMISSION_MODULES.BOXLABEL},${PERMISSION_MODULES.DISPENSING_LABEL}`,
  },
  {
    path: `${PRINT_HISTORY_PATHS.LIST}`,
    component: <SubjectLabelList />,
    module: `${PERMISSION_MODULES.SUBJECT_LABEL},${PERMISSION_MODULES.SUBJECT_ICARD_LABEL},${PERMISSION_MODULES.VACUTAINER_LABEL},${PERMISSION_MODULES.RIAVIAL_LABEL},${PERMISSION_MODULES.BOXLABEL},${PERMISSION_MODULES.DISPENSING_LABEL}`,
  },
  {
    path: ACCESSIONING_PATHS.LIST,
    component: <AccessioningList />,
    module: PERMISSION_MODULES.SESSION,
  },
  {
    path: `${ACCESSIONING_PATHS.MANUAL_ENTRY}/*`,
    component: <ManualEntryPage />,
    module: PERMISSION_MODULES.MANUAL_ENTRY,
    action: PERMISSION_ACTIONS.VIEW,
  },
  {
    path: ACCESSIONING_PATHS.LOGS,
    component: <SessionLogView />,
    module: PERMISSION_MODULES.SESSION,
  },
  {
    path: `${ACCESSIONING_PATHS.SESSION}/*`,
    component: <AccessioningSession />,
    module: PERMISSION_MODULES.SESSION,
  },
  {
    path: ACCESSIONING_PATHS.DASHBOARD,
    component: <SessionDashboard />,
    module: PERMISSION_MODULES.SESSION_DASHBOARD,
  },
  {
    path: RETENTION_PATHS.ADD,
    component: <RetentionAdd />,
    module: PERMISSION_MODULES.DRUG_RETENTION,
    action: PERMISSION_ACTIONS.ADD,
  },
  {
    path: RETENTION_PATHS.EDIT,
    component: <RetentionAdd />,
    module: PERMISSION_MODULES.DRUG_RETENTION,
    action: PERMISSION_ACTIONS.EDIT,
  },
  {
    path: RETENTION_PATHS.LIST,
    component: <RetentionList />,
    module: PERMISSION_MODULES.DRUG_RETENTION,
  },
  {
    path: RETENTION_PATHS.VIEW,
    component: <RetentionView />,
    module: PERMISSION_MODULES.DRUG_RETENTION,
    action: PERMISSION_ACTIONS.VIEW,
  },
  {
    path: DISPOSAL_PATHS.ADD,
    component: <DisposalAdd />,
    module: PERMISSION_MODULES.DRUG_DISPOSAL,
    action: PERMISSION_ACTIONS.ADD,
  },
  {
    path: DISPOSAL_PATHS.EDIT,
    component: <DisposalAdd />,
    module: PERMISSION_MODULES.DRUG_DISPOSAL,
    action: PERMISSION_ACTIONS.EDIT,
  },
  {
    path: DISPOSAL_PATHS.LIST,
    component: <DisposalList />,
    module: PERMISSION_MODULES.DRUG_DISPOSAL,
  },
  {
    path: DISPOSAL_PATHS.VIEW,
    component: <DisposalView />,
    module: PERMISSION_MODULES.DRUG_DISPOSAL,
    action: PERMISSION_ACTIONS.VIEW,
  },
  {
    path: TRANSFER_PATHS.ADD,
    component: <TransferAdd />,
    module: PERMISSION_MODULES.DRUG_TRANSFER,
    action: PERMISSION_ACTIONS.ADD,
  },
  {
    path: TRANSFER_PATHS.EDIT,
    component: <TransferAdd />,
    module: PERMISSION_MODULES.DRUG_TRANSFER,
    action: PERMISSION_ACTIONS.EDIT,
  },
  {
    path: TRANSFER_PATHS.LIST,
    component: <TransferList />,
    module: PERMISSION_MODULES.DRUG_TRANSFER,
  },
  {
    path: TRANSFER_PATHS.VIEW,
    component: <TransferView />,
    module: PERMISSION_MODULES.DRUG_TRANSFER,
    action: PERMISSION_ACTIONS.VIEW,
  },
  {
    path: STUDY_DESIGN_PATHS.TABS,
    component: <StudyDesignTabs />,
    module: PERMISSION_MODULES.STUDY_DESIGN,
  },
  {
    path: AUDIT_PATHS.LOGS,
    component: <AuditLog />,
    module: PERMISSION_MODULES.AUDIT_TRAIL,
  },
    {
    path: AUDIT_PATHS.USER_ACTIVITY,
    component: <UserActivity />,
    module: PERMISSION_MODULES.USER_ACTIVITY,
  },
  {
    path: CENTRAL_REPORTS_PATHS.DEFAULT,
    component: <ReportCenter />,
    module: PERMISSION_MODULES.ALL_REPORTS,
  },
  {
    path: CENTRAL_REPORTS_PATHS.LABEL,
    component: <ReportCenter />,
    module: PERMISSION_MODULES.LABEL_REPORTS,
  },
  {
    path: CENTRAL_REPORTS_PATHS.SESSION,
    component: <ReportCenter />,
    module: PERMISSION_MODULES.SESSION_REPORTS,
  },
  {
    path: CENTRAL_REPORTS_PATHS.STUDY,
    component: <ReportCenter />,
    module: PERMISSION_MODULES.STUDY_REPORTS,
  },
  {
    path: SCANNING_PATHS.VIEW,
    component: <ScannerPage />,
    showHeader: false,
    module: PERMISSION_MODULES.SESSION,
  },
  {
    path: `${SCANNING_PATHS.SESSION}/*`,
    component: <ScanningSessionPage />,
    showHeader: false,
    module: PERMISSION_MODULES.SESSION,
    action: `${PERMISSION_ACTIONS.SUBJECT_TO_VACUTAINER}, ${PERMISSION_ACTIONS.VACUTAINER_TO_ALIQUOT}`,
  },
  {
    path: SCANNING_PATHS.LOGS,
    component: <ScanningSessionLogView />,
    showHeader: false,
    module: PERMISSION_MODULES.SESSION,
    action: `${PERMISSION_ACTIONS.SUBJECT_TO_VACUTAINER}, ${PERMISSION_ACTIONS.VACUTAINER_TO_ALIQUOT}`,
  },
  {
    path: REPORTS_PATHS.SUMMARY,
    component: <SummaryReports />,
    module: PERMISSION_MODULES.SUMMARY_REPORTS,
  },
  {
    path: REPORTS_PATHS.STOCK_SUMMARY,
    component: <StockSummaryReport />,
    module: PERMISSION_MODULES.SUMMARY_REPORTS,
    action: PERMISSION_ACTIONS.STOCK_SUMMARY_REPORT,
  },
  {
    path: REPORTS_PATHS.EXPIRING_SOON,
    component: <StockExpiryReport />,
    module: PERMISSION_MODULES.SUMMARY_REPORTS,
    action: PERMISSION_ACTIONS.STOCK_EXPIRY_SOON_REPORT,
  },
  {
    path: REPORTS_PATHS.SUBJECT_WISE,
    component: <SubjectWiseReport />,
    module: PERMISSION_MODULES.SUMMARY_REPORTS,
    action: PERMISSION_ACTIONS.SUBJECT_WISE_STOCK_REPORT,
  },
  {
    path: REPORTS_PATHS.STOCK_LEDGER,
    component: <StockLedgerReport />,
    module: PERMISSION_MODULES.SUMMARY_REPORTS,
    action: PERMISSION_ACTIONS.STOCK_LEDGER_REPORT,
  },
  {
    path: BLOCK_VOLUNTEER_PATHS.ADD,
    component: <AddBlockVolunteer />,
    module: PERMISSION_MODULES.SUBJECTS,
    action: PERMISSION_ACTIONS.BLOCK_SUBJECT,
  },
  {
    path: BLOCK_VOLUNTEER_PATHS.EDIT,
    component: <AddBlockVolunteer />,
    module: PERMISSION_MODULES.BLOCKED_VOLUNTEER,
    action: PERMISSION_ACTIONS.EDIT,
  },
  {
    path: PRE_BLOCK_VOLUNTEER_PATHS.ADD,
    component: <AddPreBlockVolunteer />,
    // module: PERMISSION_MODULES.SUBJECTS,
    // action: PERMISSION_ACTIONS.BLOCK_SUBJECT,
  },
  {
    path: PRE_BLOCK_VOLUNTEER_PATHS.EDIT,
    component: <AddPreBlockVolunteer />,
    module: PERMISSION_MODULES.BLOCKED_VOLUNTEER,
    action: PERMISSION_ACTIONS.EDIT,
  },
  {

    path: BLOCK_VOLUNTEER_PATHS.VIEW,
    component: <ViewBlockVolunteer />,
    module: PERMISSION_MODULES.BLOCKED_VOLUNTEER,
    action: PERMISSION_ACTIONS.VIEW,
  },
  {
    path: DROPOUT_VOLUNTEER_PATHS.ADD,
    component: <AddDropoutVolunteer />,
    module: PERMISSION_MODULES.SUBJECTS,
    action: PERMISSION_ACTIONS.DROPOUT_SUBJECT,
  },
  {
    path: DROPOUT_VOLUNTEER_PATHS.EDIT,
    component: <AddDropoutVolunteer />,
    module: PERMISSION_MODULES.DROPOUT_VOLUNTEER,
    action: PERMISSION_ACTIONS.EDIT,
  },
  {
    path: DROPOUT_VOLUNTEER_PATHS.VIEW,
    component: <ViewDropoutVolunteer />,
    module: PERMISSION_MODULES.DROPOUT_VOLUNTEER,
    action: PERMISSION_ACTIONS.VIEW,
  },
  {
    path: BLOCK_VOLUNTEER_PATHS.LIST,
    component: <BlockVolunteerList />,
    module: PERMISSION_MODULES.BLOCKED_VOLUNTEER,
  },
  {
    path: DROPOUT_VOLUNTEER_PATHS.LIST,
    component: <DropoutVolunteerList />,
    module: PERMISSION_MODULES.DROPOUT_VOLUNTEER,
  },
  {
    path: TRANSFER_VOLUNTEER_PATHS.ADD,
    component: <AddTransferVolunteer />,
    module: PERMISSION_MODULES.STUDY_SCREENING,
    action: PERMISSION_ACTIONS.TRANSFER_VOLUNTEER,
  },
  {
    path: TRANSFER_VOLUNTEER_PATHS.EDIT,
    component: <AddTransferVolunteer />,
    module: PERMISSION_MODULES.TRANSFER_VOLUNTEER,
    action: PERMISSION_ACTIONS.EDIT,
  },
  {
    path: TRANSFER_VOLUNTEER_PATHS.LIST,
    component: <TransferVolunteerList />,
    module: PERMISSION_MODULES.TRANSFER_VOLUNTEER,
  },
  {
    path: TRANSFER_VOLUNTEER_PATHS.VIEW,
    component: <ViewTransferVolunteer />,
    module: PERMISSION_MODULES.TRANSFER_VOLUNTEER,
    action: PERMISSION_ACTIONS.VIEW,
  },
  {
    path: VERIFICATION_PATHS.SAMPLE_COLLECTION,
    component: <SampleCollectionVerification />,
    module: PERMISSION_MODULES.SESSION,
  },
  { path: AMBULATORY_VISIT_PATHS.LIST, component: <AmbulatoryVisitList />, module: PERMISSION_MODULES.AMBULATORY_VISIT },
  { path: AMBULATORY_VISIT_PATHS.DETAIL, component: <AmbulatoryVisitDetail />, module: PERMISSION_MODULES.AMBULATORY_VISIT, action: PERMISSION_ACTIONS.VIEW },
  { path: AMBULATORY_VISIT_PATHS.SUBJECT_DETAIL, component: <AmbulatorySubjectDetail />, module: PERMISSION_MODULES.AMBULATORY_VISIT },
  { path: AMBULATORY_VISIT_PATHS.SUBJECT_VIEW, component: <ViewAmbulatorySubjectDetail />, module: PERMISSION_MODULES.AMBULATORY_VISIT },
  { path: POST_STUDY_ASSESSMENT_PATHS.SUBJECT_DETAIL, component: <PostStudyAssessmentSubjectDetail />, module: PERMISSION_MODULES.POST_STUDY_ASSESSMENT },
  { path: AMBULATORY_VISIT_PATHS.VIEW, component: <ViewAmbulatoryVisit />, module: PERMISSION_MODULES.AMBULATORY_VISIT, action: PERMISSION_ACTIONS.VIEW },
  {
    path: DASHBOARD_PATHS.SETTINGS,
    component: <SystemSettings />,
    module: PERMISSION_MODULES.SETTINGS,
    action: PERMISSION_ACTIONS.MANAGE_SETTINGS,
  },
  {
    path: DASHBOARD_PATHS.FEATURE_ACTIVATION,
    component: <FeatureActivation />,
    module: PERMISSION_MODULES.MODULE_MANAGEMENT,
    action: PERMISSION_ACTIONS.MANAGE_MODULES,
  },
  {
    path: STORAGE_PATHS.MAIN,
    component: <StorageDashboard />,
    module: PERMISSION_MODULES.STORAGE,
  },
  {
    path: STORAGE_PATHS.UNIT_DETAIL,
    component: <StorageUnitDetail />,
    module: PERMISSION_MODULES.STORAGE,
    action: PERMISSION_ACTIONS.VIEW,
  },
  {
    path: STORAGE_PATHS.ADD,
    component: <AddStorageUnitPage />,
    module: PERMISSION_MODULES.STORAGE,
    action: PERMISSION_ACTIONS.ADD,
  },
  {
    path: STORAGE_PATHS.EDIT,
    component: <AddStorageUnitPage />,
    module: PERMISSION_MODULES.STORAGE,
    action: PERMISSION_ACTIONS.EDIT,
  },
];

const publicRoutes = [
  { path: AUTH_PATHS.LOGOUT, component: <Logout /> },
  { path: AUTH_PATHS.LOGIN, component: <Login /> },
  { path: AUTH_PATHS.MULTITAB_RESTRICT, component: <MultiTabRestrict /> },
  { path: AUTH_PATHS.UNAUTHORIZED, component: <UnauthorizedAccess /> },
  { path: AUTH_PATHS.LICENSE_EXPIRED, component: <LicenseExpired /> },
];

export { authProtectedRoutes, publicRoutes };
